module.exports = __webpack_public_path__ + "img/vuexy-logo.3d64400c.png";